var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEwiChatbotToolRename = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 3.3336L16.6667 9.16693M11.7284 3.23776C12.3492 2.56526 12.6592 2.22943 12.9892 2.03276C13.3788 1.79958 13.8229 1.67319 14.2769 1.66631C14.7309 1.65944 15.1786 1.77232 15.5751 1.9936C15.9109 2.18026 16.2309 2.50693 16.8709 3.16026C17.5109 3.81443 17.8309 4.14193 18.0126 4.48443C18.2293 4.89227 18.3396 5.34826 18.333 5.81008C18.3265 6.2719 18.2033 6.72458 17.9751 7.1261C17.7834 7.46276 17.4542 7.78026 16.7951 8.41443L8.95925 15.9619C7.71091 17.1644 7.08675 17.7653 6.30675 18.0703C5.52675 18.3753 4.66925 18.3519 2.95425 18.3078L2.72091 18.3011C2.19925 18.2878 1.93758 18.2811 1.78675 18.1086C1.63425 17.9361 1.65508 17.6703 1.69675 17.1386L1.71925 16.8503C1.83591 15.3536 1.89425 14.6053 2.18591 13.9319C2.47758 13.2586 2.98258 12.7128 3.99091 11.6203L11.7284 3.23776Z",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 18.333H18.3337",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEwiChatbotToolRename);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EWI_chatbot_tool_rename.016ccb22910e2453047e8b3e14c78a85.svg";